import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { ContextoDoRoteador } from '@/app/router';
import { NaoEncontrado } from '@/components/comuns/NaoEncontrado';
import { Toaster } from '@/components/ui/toaster';

export const Route = createRootRouteWithContext<ContextoDoRoteador>()({
  component: Raiz,
  notFoundComponent: NaoEncontrado,
});

function Raiz() {
  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}
